import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserRoundPen } from "lucide-react";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const CounselChangeOrders = ({ caseId, orders, onDraft }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get(`/cases/${caseId}/advocate-changes`).then(({ data }) => setRows(data.filter((r) => r.status === "accepted"))).catch(() => {});
  }, [caseId, orders]);
  const open = rows.filter((r) => !r.order_id);
  if (open.length === 0) return null;

  const draft = async (r) => {
    try {
      const { data } = await api.get(`/advocate-changes/${r.id}/draft-order`);
      onDraft(data);
      toast.success("Draft order prepared — review it in the composer and record it");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <section className="border border-amber-400 bg-amber-50 dark:bg-amber-950/30" data-testid="counsel-change-orders">
      <div className="px-6 py-4 border-b border-amber-300 flex items-center gap-3">
        <UserRoundPen className="h-4 w-4 text-amber-800" /><p className="label-caps">Change of counsel awaiting an order</p>
      </div>
      <ul className="divide-y divide-amber-200">
        {open.map((r) => (
          <li key={r.id} className="px-6 py-3 flex flex-wrap items-center justify-between gap-3 text-sm" data-testid={`counsel-change-${r.id}`}>
            <span>
              <strong>{r.side}</strong>: {r.old_advocate_name || "Former counsel"} → {r.new_name} ({r.new_email}), accepted {fmtDate(r.accepted_at)}
              {r.vakalatnama_document_id ? " · vakalatnama on file" : " · vakalatnama pending"}
            </span>
            <Button size="sm" onClick={() => draft(r)} data-testid={`counsel-change-draft-${r.id}`}
              className="rounded-none bg-blue-900 hover:bg-blue-800 text-white uppercase tracking-widest text-xs">
              Record change of counsel order
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
};
